/**
 * TypeWebhookCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {TypeWebhook} from '@/model/resource/TypeWebhook'

/* TODO: review generated class */
@HttpExclude()
export class TypeWebhookCollection extends PageCollection<TypeWebhook> {
  constructor() {
    super(TypeWebhook)
  }

  queryAsPage() {
    return this.listTypeWebhook()
  }

  async listTypeWebhook() {
    return await Request.get(`/admin/type-webhook`, {params: this.params})
      .name('listTypeWebhook')
      .as(this)
      .getResponse()
  }

  async listCsvTypeWebhook() {
    return await Request.get(`/admin/type-webhook/csv`, {params: this.params})
      .name('listCsvTypeWebhook')
      .as(this)
      .getResponse()
  }
}
